import { Injectable, EventEmitter,  Inject} from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class IntroTourService {
  public videowidth: any;
  public videoheight: any;
  public play = false;
  public headers: Headers;
  public source: HTMLSourceElement;
  public tooltipLayer: any;
  public adjustbuttonlayer: HTMLDivElement;
  public referenceLayer: HTMLDivElement;
  public numberstep: number;
  public ulContainer: HTMLUListElement;
  public li: HTMLLIElement;
  public a: HTMLAnchorElement;
  public onKeyDown: any;
  public arrowLayer: HTMLDivElement;
  public overlay: HTMLDivElement;
  public buttonlayer: HTMLDivElement;
  public helperLayer: HTMLDivElement;
  public videoLayer: HTMLDivElement;
  public stepNumber: HTMLSpanElement;
  public previousStep: any;
  public currentstep1 = 0;
  public currentStep = 0;
  public nextStep: any;
  public exitStep: any;
  public thanksStep: any;
  public exitFlag = true;
  public thanksFlag = false;
  public inputObject = {};
  public properObject = true;
  public waitTime: number[] = [];
  public introelement: any;
  public data: any;
  public textLayer: any;
  public introStatus = false;
  public interval: any;
  public styleText = '';
  public tooltipWidth = 0;
  public tooltipHeight = 20;
  public initiated = false;
  public steps: any;
  public autoplay: boolean;
  public videoElement: any;
  public isIntroServiceActive = false;
  public navigateToNextPage: EventEmitter<any> = new EventEmitter<any>();

  constructor(@Inject(DOCUMENT) private _document: any) {
    this.helperLayer = this._document.createElement('div');
    this.videoLayer = this._document.createElement('div');
    this.videoLayer.setAttribute('id', 'intro_video_element');
    this.videoLayer.setAttribute('class', 'video-intro-element');
  }

  show(obj: any) {
    console.log('start ', obj);
  }

  setOptions(obj: any) {
    this.isIntroServiceActive = false;
    this.properObject = true;
    this.inputObject = obj;
    this.steps = this.inputObject['steps'];
    this.videoheight = obj.videoHeight;
    this.videowidth = obj.videoWidth;
    this.data = obj;
    this.tooltipWidth = obj.tooltipMaxWidth ? obj.tooltipMaxWidth : 300;
    this.tooltipHeight = obj.tooltipHeight ? obj.tooltipHeight : 200;
    this.autoplay = obj.autoplay ? obj.autoplay : false;
    this.verifyIDs(obj);
  }

  verifyIDs(obj: any) {
    for (let i = 0; i < this.steps.length; i++) {
      if (this._document.getElementById(this.steps[i].element) == null) {
        this.properObject = false;
        break;
      }
    }
  }

  start() {
    if (this.introStatus === true) {
      alert('one instance of Intro is already running ');
    } else if (this.properObject === false) {
      alert('Some Ids are not available. Please input correct IDs');
    } else {
      this.play = true;
      this.currentStep = 0;
      this.goToSteps();
    }
  }

  goToSteps() {
    let self: any = '';
    self = this;
    let resetTime = 0;
    let i = 0;
    this.waitTime[0] = this.steps[this.currentStep].waitTime;
    this.showContent();
    this.moveToStep();
    if (this.autoplay === true) {
      this.getWaitTimes();
      this.interval = setInterval(() => {
        if (resetTime >= self.waitTime[i]) {
          self.moveToStep();
          resetTime = 0;
          i++;
        } else {
          resetTime += 1000;
        }
      }, 1000);
    }
  }

  moveToStep() {
    const len = this.steps.length - 1;
    this.introStatus = true;
    if (this.currentStep <= len) {
      this.introelement = this.steps[this.currentStep].intro;
      this.tooltipbox(this.introelement);
    }
    if (
      this._document.querySelectorAll('#intro_container a.active') !== undefined &&
      this._document.querySelectorAll('#intro_container a.active').length !== 0
    ) {
      this._document.querySelectorAll('#intro_container a.active')[0].className = '';
    }

    if (this.currentStep === 0) {
      this._addClass(this._document.getElementById(this.steps[this.currentStep].element), 'current-intro-element');
      const previousBtnElement = this._document.getElementById('prv_Btn');
      const nextBtnElement = this._document.getElementById('nxt_Btn');
      const exitBtnElement = this._document.getElementById('ext_Btn');
      const thanksBtnElement = this._document.getElementById('thanks_Btn');
      previousBtnElement.setAttribute('disabled', 'disabled');
      nextBtnElement.removeAttribute('disabled');
      if (this.currentStep === len) {
        // incase there is only one step in intro
        nextBtnElement.setAttribute('disabled', 'disabled');
        exitBtnElement.style.display = 'none';
        thanksBtnElement.style.visibility = 'visible';
      } else {
        // incase there are only 2 steps then thanks button is not hidding
        exitBtnElement.style.display = 'inherit';
        thanksBtnElement.style.visibility = 'hidden';
      }
    } else if (this.currentStep === len) {
      this._addClass(this._document.getElementById(this.steps[this.currentStep].element), 'current-intro-element');
      this._document.getElementById(
        this.steps[this.currentStep - 1].element
      ).className = this._document
        .getElementById(this.steps[this.currentStep - 1].element)
        .className.replace(/\bcurrent-intro-element\b/, '');
      this._document.getElementById('prv_Btn').removeAttribute('disabled');
      this._document.getElementById('nxt_Btn').setAttribute('disabled', 'disabled');
      this._document.getElementById('ext_Btn').style.display = 'none';
      this._document.getElementById('thanks_Btn').style.visibility = 'visible';
    } else if (this.currentStep < len) {
      this._addClass(this._document.getElementById(this.steps[this.currentStep].element), 'current-intro-element');

      this._document.getElementById(
        this.steps[this.currentStep - 1].element
      ).className = this._document
        .getElementById(this.steps[this.currentStep - 1].element)
        .className.replace(/\bcurrent-intro-element\b/, '');
      this._document.getElementById('prv_Btn').removeAttribute('disabled');
      this._document.getElementById('nxt_Btn').removeAttribute('disabled');
      this._document.getElementById('ext_Btn').style.display = 'inherit';
      this._document.getElementById('thanks_Btn').style.visibility = 'hidden';
    } else {
      this._document.getElementById(
        this.steps[this.currentStep - 1].element
      ).className = this._document
        .getElementById(this.steps[this.currentStep - 1].element)
        .className.replace(/\bcurrent-intro-element\b/, '');
      this.exit();
    }

    if (this.currentStep <= len) {
      this.adjustTooltipPosition(
        this.steps[this.currentStep].element,
        this.steps[this.currentStep].position
      );
      this.adjustReferenceLayerPosition(this.steps[this.currentStep].element);
      if (
        this._document.querySelectorAll('#intro_container a.active') !== undefined
      ) {
        this._document.querySelectorAll('#intro_container a')[
          this.currentStep
        ].className =
          'active';
        this.numberstep = this.currentStep + 1;
        this._document.getElementById('axis_intro_step_number_id').innerHTML =
          '' + this.numberstep;
      } else {
        this._document.querySelectorAll('#intro_container a')[
          this.currentStep
        ].className =
          '';
      }
      const targetElement = this._document.getElementById(
        this.steps[this.currentStep].element
      );

      const currentElementPosition = this._getPropValue(
        targetElement,
        'position'
      );
      if (
        currentElementPosition !== 'absolute' &&
        currentElementPosition !== 'relative' &&
        currentElementPosition !== 'fixed'
      ) {
        this._addClass(targetElement, 'introjs-relativePosition');

      }

      let parentElm: any = targetElement.parentNode;
      while (parentElm != null) {
        if (!parentElm.tagName || parentElm.tagName.toLowerCase() === 'body') {
          break;
        }
        const zIndex = this._getPropValue(parentElm, 'z-index');
        const opacity = parseFloat(this._getPropValue(parentElm, 'opacity'));
        const transform =
          this._getPropValue(parentElm, 'transform') ||
          this._getPropValue(parentElm, '-webkit-transform') ||
          this._getPropValue(parentElm, '-moz-transform') ||
          this._getPropValue(parentElm, '-ms-transform') ||
          this._getPropValue(parentElm, '-o-transform');
        if (
          /[0-9]+/.test(zIndex) ||
          opacity < 1 ||
          (transform !== 'none' && transform !== undefined)
        ) {
          this._addClass(parentElm, 'introjs-fixParent');
        }
        parentElm = parentElm.parentNode;
      }

      if (this.steps[this.currentStep].videoHtml === undefined) {
        this._document.getElementById('intro_video_element').style.display = 'none';
      } else {
        this._document.getElementById('intro_video_element').style.display = 'block';
      }
      this._document.getElementById('intro_video_element').innerHTML = this.steps[
        this.currentStep
      ].videoHtml;
      this.currentStep++;
    }
  }

  _getPropValue(element, propName) {
    let propValue = '';
    if (element.currentStyle) { // IE
      propValue = element.currentStyle[propName];
    } else if (this._document.defaultView && this._document.defaultView.getComputedStyle) { // Others
      propValue = this._document.defaultView.getComputedStyle(element, null).getPropertyValue(propName);
    }
    // Prevent exception in IE
    if (propValue && propValue.toLowerCase) {
      return propValue.toLowerCase();
    } else {
      return propValue;
    }
  }

  _addClass(element, className) {
    if (element instanceof SVGElement) {
      const pre = element.getAttribute('class') || '';
      element.setAttribute('class', pre + ' ' + className);
    } else {
      if (element.classList !== undefined) {
        const classes = className.split(' ');
        for (let i = 0, len = classes.length; i < len; i++) {
          element.classList.add(classes[i]);
        }
      }
    }
  }

  tooltipbox(introelement) {
    this.helperLayer.className = 'introjs-tooltip';
    this.helperLayer.id = 'intro_container';
    this.helperLayer.style.zIndex = '' + 100000000;
    this.helperLayer.style.maxWidth = '' + this.tooltipWidth;
    const targetElement = this._document.body;
    targetElement.appendChild(this.helperLayer);
    targetElement.appendChild(this.videoLayer);
    this.textLayer.innerHTML = introelement;
  }

  cleartext() {
    this.textLayer.innerHTML = '';
    this.nextStep.innerHTML = '';
    this.previousStep.innerHTML = '';
    this.exitStep.innerHTML = '';
  }

  showContent() {
    this.referenceLayer = this._document.createElement('div');
    this.referenceLayer.id = 'intro-reference-layer-id';
    this.referenceLayer.className = 'intro-reference-layer-cls';
    this.stepNumber = this._document.createElement('span');
    this.stepNumber.id = 'axis_intro_step_number_id';
    this.stepNumber.className = 'axis-intro-step-number';
    this.referenceLayer.appendChild(this.stepNumber);
    this._document.body.appendChild(this.referenceLayer);
    this.arrowLayer = this._document.createElement('div');
    this.arrowLayer.className = 'introjs-arrow';
    this.helperLayer.appendChild(this.arrowLayer);
    this.textLayer = this._document.createElement('div');
    this.textLayer.className = 'introjs-tooltiptext';
    this.helperLayer.appendChild(this.textLayer);
    this.buttonlayer = this._document.createElement('div');
    this.buttonlayer.className = 'axis-intro-bullets';
    this.buttonlayer.setAttribute('role', 'presentation');
    this.helperLayer.appendChild(this.buttonlayer);
    this.ulContainer = this._document.createElement('ul');
    this.ulContainer.setAttribute('role', 'tablist');
    this.li = this._document.createElement('li');
    this.a = this._document.createElement('a');
    this.a.className = 'active';
    this.li.appendChild(this.a);
    this.a.addEventListener('click', () => {
      this.jumpToStep(0);
    });
    this.ulContainer.appendChild(this.li);
    for (let i = 1; i < this.steps.length; i++) {
      this.li = this._document.createElement('li');
      this.a = this._document.createElement('a');
      this.li.appendChild(this.a);
      this.ulContainer.appendChild(this.li);

      this.a.addEventListener('click', () => {
        this.jumpToStep(i);
      });
    }

    this.buttonlayer.appendChild(this.ulContainer);
    this.adjustbuttonlayer = this._document.createElement('div');
    this.adjustbuttonlayer.className = 'axis-buttons';
    this.helperLayer.appendChild(this.adjustbuttonlayer);
    this.nextStep = this._document.createElement('button');
    this.nextStep.innerHTML = this.data.nextLabel;
    this.nextStep.id = 'nxt_Btn';
    this.nextStep.className = 'introjs-button introjs-nextbutton';
    this.nextStep.setAttribute('role', 'button');
    this.nextStep.addEventListener('click', () => {
      this.next();
    });
    this.adjustbuttonlayer.appendChild(this.nextStep);
    this.previousStep = this._document.createElement('button');
    this.previousStep.innerHTML = this.data.prevLabel;
    this.previousStep.id = 'prv_Btn';
    this.previousStep.className = 'introjs-button introjs-prevbutton';
    this.previousStep.setAttribute('role', 'button');
    this.previousStep.addEventListener('click', () => {
      this.prev();
    });
    this.adjustbuttonlayer.appendChild(this.previousStep);
    this.exitStep = this._document.createElement('button');
    this.exitStep.innerHTML = this.data.skipLabel;
    this.exitStep.id = 'ext_Btn';
    this.exitStep.className = 'introjs-button introjs-skipbutton';
    this.exitStep.setAttribute('role', 'button');
    this.adjustbuttonlayer.appendChild(this.exitStep);
    this.exitStep.addEventListener('click', () => {
      this.exit();
    });

    this.thanksStep = this._document.createElement('button');
    this.thanksStep.innerHTML = (this.data && this.data.isNextpageAvailabe) ? 'Next Page' : this.data.doneLabel;
    this.thanksStep.id = 'thanks_Btn';
    this.thanksStep.className = 'introjs-button introjs-thanksButton';
    this.thanksStep.setAttribute('role', 'button');
    this.thanksStep.style.visibility = 'hidden';
    this.thanksStep.addEventListener('click', () => {
      this.exit();
      this.sendNavigationCallBack();
    });
    this.adjustbuttonlayer.appendChild(this.thanksStep);
    this.helperLayer.appendChild(this.adjustbuttonlayer);
    this.overlay = this._document.createElement('div');
    this.overlay.className = 'introjs-overlay';
    this.styleText +=
      'top: 0;bottom: 0; left: 0;right: 0;position: fixed;opacity:0.8';
    this.overlay.setAttribute('style', this.styleText);

    this.overlay.addEventListener('click',() => {
      this.exit();
    });
    this._document.body.appendChild(this.overlay);
    this.keyboard();
    this.listeners();
  }

  jumpToStep(num) {
    const steps = this.steps;
    this._document.getElementById(steps[this.currentStep - 1].element).classList.remove('current-intro-element');
    this._document.getElementById(steps[this.currentStep - 1].element).classList.remove('introjs-relativePosition');
    this.currentStep = num;
    this.moveToStep();
  }

  adjustReferenceLayerPosition(id) {
    const targetLayer = this._document.getElementById(id);
    if (targetLayer) {
      const targetOffset = targetLayer.getBoundingClientRect();
      const referenceLayer = this._document.getElementById('intro-reference-layer-id');
      referenceLayer.style.top = targetOffset.top + window.scrollY - 7 + 'px' ;
      referenceLayer.style.left = targetOffset.x + targetOffset.width - 7 + 'px';
    }
  }

  adjustTooltipPosition(id, position) {
    const targetOffset = this._document.getElementById(id).getBoundingClientRect();
    const tooltipLayer = this._document.getElementById('intro_container');
    const w = this._document.body.clientWidth;
    const h = this._document.body.clientHeight;
    position = position ? position : 'top'; // if user doesn't specify postion, set default position to top
    switch (position) {
      case 'top': {
        if ((w - targetOffset.right > this.tooltipWidth + 50) && (h - targetOffset.bottom > this.tooltipHeight + 50)) {
          // check for right and bottom
          this.arrowLayer.className = 'introjs-arrow left';
          this.adjustTooltipToRight(targetOffset, tooltipLayer);
        } else if ( (h - targetOffset.bottom > this.tooltipHeight + 50) && (w - targetOffset.right > this.tooltipWidth + 50)) {
          // check for bottom and right
          this.arrowLayer.className = 'introjs-arrow top';
          this.adjustTooltipToBottom(targetOffset, tooltipLayer);
        } else if ((targetOffset.left > this.tooltipWidth + 50) && (h - targetOffset.bottom > this.tooltipHeight + 50) ) {
          // check for left and bottom
          this.arrowLayer.className = 'introjs-arrow right';
          this.adjustTooltipToLeft(targetOffset, tooltipLayer);
        } else {
          this.arrowLayer.className = 'introjs-arrow bottom';
          this.adjustTooltipToTop(targetOffset, tooltipLayer);
        }
        break;
      }
      case 'bottom': {
        if ((targetOffset.left > this.tooltipWidth + 50) && (h - targetOffset.bottom > this.tooltipHeight + 50)) {
          this.arrowLayer.className = 'introjs-arrow right';
          this.adjustTooltipToLeft(targetOffset, tooltipLayer);
        } else if ((targetOffset.top > this.tooltipHeight + 50) && (w - targetOffset.right > this.tooltipWidth + 50)) {
          this.arrowLayer.className = 'introjs-arrow bottom';
          this.adjustTooltipToTop(targetOffset, tooltipLayer);
        } else if ((w - targetOffset.right > this.tooltipWidth + 50) && (h - targetOffset.bottom > this.tooltipHeight + 50)) {
          this.arrowLayer.className = 'introjs-arrow left';
          this.adjustTooltipToRight(targetOffset, tooltipLayer);
        } else {
          this.arrowLayer.className = 'introjs-arrow top';
          this.adjustTooltipToBottom(targetOffset, tooltipLayer);
        }
        break;
      }

      case 'right': {
        if ((h - targetOffset.bottom > this.tooltipHeight + 50) && (w - targetOffset.right > this.tooltipWidth + 50)) {
          this.arrowLayer.className = 'introjs-arrow top';
          this.adjustTooltipToBottom(targetOffset, tooltipLayer);
        } else if ((targetOffset.left > this.tooltipWidth + 50) && (h - targetOffset.bottom > this.tooltipHeight + 50)) {
          this.arrowLayer.className = 'introjs-arrow right';
          this.adjustTooltipToLeft(targetOffset, tooltipLayer);
        } else if ((targetOffset.top > this.tooltipHeight + 50) && (w - targetOffset.right > this.tooltipWidth + 50)) {
          this.arrowLayer.className = 'introjs-arrow bottom';
          this.adjustTooltipToTop(targetOffset, tooltipLayer);
        } else {
          this.arrowLayer.className = 'introjs-arrow left';
          this.adjustTooltipToRight(targetOffset, tooltipLayer);
        }
        break;
      }
      case 'left': {
        if ((targetOffset.top > this.tooltipHeight + 50) && (w - targetOffset.right > this.tooltipWidth + 50)) {
          this.arrowLayer.className = 'introjs-arrow bottom';
          this.adjustTooltipToTop(targetOffset, tooltipLayer);
        } else if ((w - targetOffset.right > this.tooltipWidth + 50) && (h - targetOffset.bottom > this.tooltipHeight + 50)) {
          this.arrowLayer.className = 'introjs-arrow left';
          this.adjustTooltipToRight(targetOffset, tooltipLayer);
        } else if ((h - targetOffset.bottom > this.tooltipHeight + 50) && (w - targetOffset.right > this.tooltipWidth + 50)) {
          this.arrowLayer.className = 'introjs-arrow top';
          this.adjustTooltipToBottom(targetOffset, tooltipLayer);
        } else {
          this.arrowLayer.className = 'introjs-arrow right';
          this.adjustTooltipToLeft(targetOffset, tooltipLayer);
        }
        break;
      }
    }

    setTimeout(() => {
      this.adjustVideoLayer();
    }, 300);
  }

  adjustVideoLayer() {
    const videoLayer = this._document.getElementById('intro_video_element');
    const tooltipLayer = this._document.getElementById('intro_container');
    if (this._document.getElementById('intro_video_element')) {
    if (this._document.getElementById('intro_video_element').innerHTML === 'undefined') {
      this._document.body.removeChild(this._document.getElementById('intro_video_element'));
    } else if (tooltipLayer) {
      const tooltipElement = tooltipLayer.getBoundingClientRect();
      videoLayer.style.top = tooltipElement.bottom + 'px';
      videoLayer.style.left = tooltipElement.left + 'px';
    }
  }
  }

  adjustTooltipToTop(targetOffset, tooltipLayer) {
    tooltipLayer.style.top = targetOffset.top - tooltipLayer.clientHeight - 12 + window.scrollY +  'px' ;
    tooltipLayer.style.left = targetOffset.left + 'px';
  }

  adjustTooltipToRight(targetOffset, tooltipLayer) {
    tooltipLayer.style.left = targetOffset.right + 10 + 'px';
    tooltipLayer.style.top = targetOffset.top + window.scrollY + 'px' ;
  }

  adjustTooltipToBottom(targetOffset, tooltipLayer) {
    tooltipLayer.style.top = targetOffset.bottom + 10 +  window.scrollY + 'px' ;
    tooltipLayer.style.left = targetOffset.left  + 'px';
  }

  adjustTooltipToLeft(targetOffset, tooltipLayer) {
    tooltipLayer.style.left = targetOffset.left - tooltipLayer.clientWidth - 12 + 'px';
    tooltipLayer.style.top = targetOffset.top + window.scrollY + 'px' ;
  }


  next() {
    this.currentStep = this.currentStep - 1;
    if (this.currentStep < this.steps.length) {
      ++this.currentStep;
    }
    this.moveToStep();
  }

  prev() {
    --this.currentStep;
    if (this.currentStep > 0) {
      const steps = this.steps;
      this._document.getElementById(steps[this.currentStep].element).classList.remove('current-intro-element');
      this._document.getElementById(steps[this.currentStep].element).classList.remove('introjs-relativePosition');
      --this.currentStep;
    }
    this.moveToStep();
  }

  keyboard() {
    this.onKeyDown = (e) => {
      let code = e.code === null ? e.which : e.code;

      if (code === null) {
        code = e.charCode === null ? e.keyCode : e.charCode;
      }

      if (code === 'Escape' || code === 27) {
        this.exit();
      } else if (code === 'ArrowLeft' || code === 37) {
        this.prev();
      } else if (code === 'ArrowRight' || code === 39) {
        this.next();
      } else {
        this.exit();
      }
    };
  }
  listeners() {
    if (window.addEventListener) {
      window.addEventListener('keydown', this.onKeyDown, true);
    } else if (this._document.addEventListener) {
      // IE
      this._document.addEventListener('onkeydown', this.onKeyDown);
    }
  }

  sendNavigationCallBack() {
    if (this.data && this.data.isNextpageAvailabe) {
      this.isIntroServiceActive = true;
      // send callback;
      this.onNavigateToNextPage();
    }
  }

  public onNavigateToNextPage() {
    this.navigateToNextPage.emit();
  }

  exit() {
    this.play = false;
    clearInterval(this.interval);
    this.referenceLayer.removeChild(this.stepNumber);
    this._document.body.removeChild(this.referenceLayer);
    // this.helperLayer.removeChild(this.stepNumber);
    this.li.removeChild(this.a);
    this.ulContainer.removeChild(this.li);
    this.buttonlayer.removeChild(this.ulContainer);
    this.helperLayer.removeChild(this.buttonlayer);
    this.introStatus = false;
    this._document.body.removeChild(this.overlay);
    this._document.getElementById(this.steps[this.currentStep - 1].element).classList.remove('current-intro-element');
    this._document.getElementById(this.steps[this.currentStep - 1].element).classList.remove('introjs-relativePosition');
    this.helperLayer.removeChild(this.textLayer);
    this.adjustbuttonlayer.removeChild(this.nextStep);
    this.adjustbuttonlayer.removeChild(this.previousStep);
    this.adjustbuttonlayer.removeChild(this.exitStep);
    this.adjustbuttonlayer.removeChild(this.thanksStep);
    this.helperLayer.removeChild(this.adjustbuttonlayer);
    this.helperLayer.removeChild(this.arrowLayer);
    this._document.body.removeChild(this._document.getElementById('intro_container'));
    window.removeEventListener('keydown', this.onKeyDown, true);

    if (
      this._document.querySelectorAll('#intro_video_element video source')[0] !==
      undefined
    ) {
        this._document.body.removeChild(this._document.getElementById('intro_video_element'));
    }

    const fixParents = this._document.querySelectorAll('.introjs-fixParent');
    if (fixParents && fixParents.length > 0) {
      for (let i = fixParents.length - 1; i >= 0; i--) {
        fixParents[i].classList.remove('introjs-fixParent');
      }
    }

    this.isIntroServiceActive = false;
  }

  getWaitTimes() {
    const l = this.steps.length;
    for (let i = 0; i < l; i++) {
      this.waitTime[i] = this.steps[i].waitTime;
    }
  }
}
